import React, {useCallback, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import SimilarProductsList from "./similarProductsList";
import {getFeaturesCollectionsList} from "./similarProductsFunctions";

const SimilarProducts = (props) => {

  const {filterGroups, cartItems, quoteIndex} = props;
  const [similarOpened, setSimilarOpened] = useState(true);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  const addedCountertops = cartItems.filter(cItem => cItem.currentQuote === quoteIndex && cItem.partId.includes("countertop"));
  const cartItem = addedCountertops[0];

  const featuresCollectionsList = getFeaturesCollectionsList(cartItem, filterGroups);
  if (!featuresCollectionsList || !featuresCollectionsList.length) {
    return null
  }

  const styles = {};
  if (similarOpened) {
    // styles.height = featuresCollectionsList.length > 3 ? 300 : (featuresCollectionsList.length * 75) + 30 // each item + title
    styles.height = (featuresCollectionsList.length * 55) + 45 // each item + title
  }

  return (
    <div className="scart-block__list-item scart-block__list-item--similar">
      <div className={"similar" + (similarOpened ? " similar--opened" : "")} style={styles}>
        <span className="similar-title">
          <FormattedMessage id="similar.title"/>
        </span>
        <SimilarProductsList subPart={{part: cartItem.cartFeature.getParent()}}
                             featuresCollectionsList={featuresCollectionsList}
                             updateParent={forceUpdate}
                             cartItem={cartItem}
                             addedCountertops={addedCountertops}
                             quoteIndex={quoteIndex} />
      </div>
      <button className="ui-button4 ui-button4--green" onClick={() => setSimilarOpened(!similarOpened)}>
        <FormattedMessage id={similarOpened ? "similar.buttonClose" : "similar.buttonOpen"}/>
      </button>
    </div>
  )
};

SimilarProducts.propTypes = {
  quoteIndex: PropTypes.number.isRequired,
};

const mapStateToProps = (store) => {
  return {
    filterGroups: store.filterState.filterGroups,
    fabricatorData: store.fabricatorState,
    cartItems: store.cartState.cartItems,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SimilarProducts)
)
